export const FETCH_LMS_NOTIFICATION_REQUEST = '@syllabuses/FETCH_LMS_NOTIFICATION_REQUEST';
export const FETCH_LMS_NOTIFICATION_SUCCESS = '@syllabuses/FETCH_LMS_NOTIFICATION_SUCCESS';
export const FETCH_LMS_NOTIFICATION_FAILURE = '@syllabuses/FETCH_LMS_NOTIFICATION_FAILURE';
